import { GraphqlAddToCartProvider } from './infrastructure';
import { AddToCartProvider } from './domain';

export * from './domain';
export * from './infrastructure';

const addToCartProvider: AddToCartProvider = new GraphqlAddToCartProvider();

export { addToCartProvider };
